import { green } from '../colors';
export const primaryColor = (mode)=>{
    return mode === 'light' ? {
        main: green[600],
        highContrast: green[800],
        lowContrast: green[150]
    } : {
        main: green[500],
        highContrast: green[300],
        lowContrast: green[700]
    };
};

//# sourceMappingURL=primary.js.map